import React from 'react';
import './Facilities.css';
import useReveal from '../hooks/useReveal';
import { facilities } from '../data/schoolData';
import computerLabImg from '../assets/images/computerlab.jpeg';
import buildingWideImg from '../assets/images/building-wide.jpg';
import playParkImg from '../assets/images/playpark.jpeg';
import playgroundImg from '../assets/images/playground.jpeg';
import schoolGroundImg from '../assets/images/schoolground.jpeg';
import schoolGateImg from '../assets/images/principaloffice.jpeg';

const facilityImages = {
  'computerlab.jpeg': computerLabImg,
  'building-wide.jpg': buildingWideImg,
  'playpark.jpeg': playParkImg,
  'playground.jpeg': playgroundImg,
  'schoolground.jpeg': schoolGroundImg,
  'principaloffice.jpeg': schoolGateImg,
};

function FacCard({ icon, title, text, image }) {
  const ref = useReveal();
  const imgSrc = image ? facilityImages[image] : null;

  return (
    <div className="fac-card reveal" ref={ref}>
      {imgSrc && (
        <div className="fac-img">
          <img src={imgSrc} alt={title} />
        </div>
      )}
      <div className="fac-top" />
      <div className="fac-body">
        {!imgSrc && <div className="fac-ico">{icon}</div>}
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
}

export default function Facilities() {
  const hRef = useReveal();
  return (
    <section className="section facilities-section" id="facilities">
      <div className="container">
        <div className="section-head center reveal" ref={hRef}>
          <span className="stag">Our Infrastructure</span>
          <h2 className="stitle">What We Offer</h2>
          <div className="sline center" />
        </div>
        <div className="fac-grid">
          {facilities.map(f => <FacCard key={f.title} {...f} />)}
        </div>
      </div>
    </section>
  );
}
